import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
} from '@packages/systems/wfdl-ast';

export const LayoutFeaturesMetrics = {
  factory: EElement({
    id: '9c78a179-f64f-3ba4-4119-c05078511ee9',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('be317a36-21a1-9592-7a64-f307e3fcf264')]),
      children: EList([
        EElement({
          id: '9c78a179-f64f-3ba4-4119-c05078511eea',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '33a67574-dbd9-ae34-cce5-3b176ea07efb',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('d93a4e1c-472e-f2ae-bbf1-001079e69611'),
                  ]),
                  children: EList([
                    EElement({
                      id: '5bdab7fb-6f25-9bb3-8826-1f83bd86349b',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('d6989134-3e45-b6e9-42a9-d0e0f98ade87'),
                        ]),
                        children: EList([
                          EElement({
                            id: '6cad27ec-d7ca-200e-f01a-18bd77966e49',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('f8f25a0b-5153-128e-064b-a67693ec4541'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '6cad27ec-d7ca-200e-f01a-18bd77966e4a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('12'),
                                }),
                                EElement({
                                  id: 'fd1af27c-e13b-3e63-8ce3-561e2441cff8',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Span')
                                  ),
                                  data: ERecord({
                                    styleBlockIds: EList([
                                      EText(
                                        '05a9f3df-26b8-ed86-1cef-e05ba2b5af11'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'd72ce80a-bdbb-6d7a-9741-5fe43835d692',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('%'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '632da76f-ad12-841c-e307-4e0d751f26f7',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              children: EList([
                                EElement({
                                  id: '632da76f-ad12-841c-e307-4e0d751f26f8',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Metric description'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '1e48b402-58d6-639d-1c56-cedf5bc89be1',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('d6989134-3e45-b6e9-42a9-d0e0f98ade87'),
                        ]),
                        children: EList([
                          EElement({
                            id: '1e48b402-58d6-639d-1c56-cedf5bc89be2',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('f8f25a0b-5153-128e-064b-a67693ec4541'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '1e48b402-58d6-639d-1c56-cedf5bc89be3',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('87'),
                                }),
                                EElement({
                                  id: '0b184067-8978-78e6-15dd-4c2774488052',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Span')
                                  ),
                                  data: ERecord({
                                    styleBlockIds: EList([
                                      EText(
                                        '05a9f3df-26b8-ed86-1cef-e05ba2b5af11'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'eee81acd-3c22-92d1-2965-c8eec8d852b6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('%'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '1e48b402-58d6-639d-1c56-cedf5bc89be6',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              children: EList([
                                EElement({
                                  id: '1e48b402-58d6-639d-1c56-cedf5bc89be7',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Metric description'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'baa8e98a-ecf3-91a7-d414-701097ddea9b',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('d6989134-3e45-b6e9-42a9-d0e0f98ade87'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'baa8e98a-ecf3-91a7-d414-701097ddea9c',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('f8f25a0b-5153-128e-064b-a67693ec4541'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'baa8e98a-ecf3-91a7-d414-701097ddea9d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('$5000'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'baa8e98a-ecf3-91a7-d414-701097ddeaa0',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              children: EList([
                                EElement({
                                  id: 'baa8e98a-ecf3-91a7-d414-701097ddeaa1',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Metric description'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '232dfe06-cb6f-2746-3922-3f34eb9c2392',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('d6989134-3e45-b6e9-42a9-d0e0f98ade87'),
                        ]),
                        children: EList([
                          EElement({
                            id: '232dfe06-cb6f-2746-3922-3f34eb9c2393',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              styleBlockIds: EList([
                                EText('f8f25a0b-5153-128e-064b-a67693ec4541'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '232dfe06-cb6f-2746-3922-3f34eb9c2394',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('87'),
                                }),
                                EElement({
                                  id: '87b39d61-f8bd-5ce2-d82c-025daf89ca60',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Span')
                                  ),
                                  data: ERecord({
                                    styleBlockIds: EList([
                                      EText(
                                        '05a9f3df-26b8-ed86-1cef-e05ba2b5af11'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'f7315a78-b166-3d9a-901a-0120cac90839',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('%'),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '232dfe06-cb6f-2746-3922-3f34eb9c2397',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              tag: EEnum('div'),
                              children: EList([
                                EElement({
                                  id: '232dfe06-cb6f-2746-3922-3f34eb9c2398',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Metric description'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'be317a36-21a1-9592-7a64-f307e3fcf264',
      type: 'class',
      name: 'Features Metrics',
      comb: '',
      styleLess:
        'position: relative; padding-top: 60px; padding-right: 30px; padding-bottom: 60px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'd93a4e1c-472e-f2ae-bbf1-001079e69611',
      type: 'class',
      name: 'Features Wrapper',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-around; align-items: center;',
      children: [],
      variants: {
        medium: {styleLess: 'justify-content: space-between;'},
        small: {styleLess: 'margin-bottom: -40px; flex-wrap: wrap;'},
      },
    },
    {
      _id: 'd6989134-3e45-b6e9-42a9-d0e0f98ade87',
      type: 'class',
      name: 'Features Block',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; justify-content: flex-start; align-items: center; text-align: center;',
      children: [],
      variants: {small: {styleLess: 'width: 50%; margin-bottom: 40px;'}},
    },
    {
      _id: 'f8f25a0b-5153-128e-064b-a67693ec4541',
      type: 'class',
      name: 'Features Title',
      comb: '',
      styleLess:
        'margin-bottom: 8px; font-size: 40px; line-height: 48px; font-weight: 600;',
      children: [],
      variants: {},
    },
    {
      _id: '05a9f3df-26b8-ed86-1cef-e05ba2b5af11',
      type: 'class',
      name: 'Features Title Small',
      comb: '',
      styleLess: 'font-size: 24px; line-height: 32px;',
      children: [],
      variants: {},
    },
  ],
} as const;
